export const COMMENT_OPTIONS = [
  'General Comment',
  'Adhesion Bothsides',
  'Adhesion Left',
  'Adhesion Right',
  'Banamine',
  'Down in Chute',
  'High Risk OPU',
  'K1',
  'K1/Banamine',
  'Moves in Chute',
  'No Epidural',
  'NO OPU',
  'Open',
  'Pregnant',
  'Scarred Rectum',
  'Tight Rectum',
  'Too far Pregnant',
  'Rest',
  'Missing',
  'Re-Check',
];

export const RATE_OPTIONS = [
  { label: 'slight', value: 'slight' },
  { label: 'moderate', value: 'moderate' },
  { label: 'severe', value: 'severe' },
];

export const INSTRUCTION_OPTIONS = [
  { label: 'no rest', value: 'no rest' },
  { label: '3 week rest', value: '3 week rest' },
  { label: '4 week rest', value: '4 week rest' },
  { label: 'DONE', value: 'DONE' },
];

export const REST_OPTIONS = [
  { label: '1 week rest', value: '1 week rest' },
  { label: '2 week rest', value: '2 week rest' },
  { label: '3 week rest', value: '3 week rest' },
  { label: '4 week rest', value: '4 week rest' },
  { label: 'DONE', value: 'DONE' },
];

export const TEMPERATURE_OPTIONS = [
  { label: 'Low', value: 'low' },
  { label: 'Medium', value: 'medium' },
  { label: 'High', value: 'high' },
];

export const PRESSURE_OPTIONS = [
  { label: 'Low', value: 'low' },
  { label: 'Medium', value: 'medium' },
  { label: 'High', value: 'high' },
];

export const OVARY_SIDE_OPTIONS = [
  { label: 'Left', value: 'Left' },
  { label: 'Right', value: 'Right' },
];

export const FARBRO_SITE_ID = '087071b7-cdb2-e911-818b-005056975fe0';

export const QC_REQUIRED_FIELDS = [
  'tog_qc_pockettubewarmertemp',
  'tog_qc_pumptubewarmertemp',
  'tog_qc_pumppressure',
  'tog_qc_outsidetemp',
  'tog_qc_outsideweatherconditions',
  'tog_qc_collectionroomtemp',
  'tog_qc_brennerneedlelotno',
];
